// === Static Imports (항상 필요한 컴포넌트들) ===
import Home from "../views/Home.vue";
import Information from "../views/authservice/Information.vue";

// === Dynamic Imports (코드 분할을 위한 지연 로딩) ===
// Core AuthService Components
const ServiceInit = () => import("../views/authservice/ServiceInit.vue");
const ServiceIntro = () => import("../views/authservice/ServiceIntro.vue");
const WarrantyPeriod = () => import("../views/authservice/WarrantyPeriod.vue");
const CreateAuthcode = () => import("../views/authservice/CreateAuthcode.vue");
const ManageAuthcode = () => import("../views/authservice/ManageAuthcode.vue");
const ManageAuthMembers = () => import("../views/authservice/ManageAuthMembers.vue");
const LostRecord = () => import("../views/authservice/LostRecord.vue");
const Printqr = () => import("../views/authservice/Printqr.vue");
const Setting = () => import("../views/authservice/Setting.vue");
const Payment = () => import("../views/authservice/Payment.vue");
const AdditionalService = () => import("../views/authservice/AdditionalService.vue");
const ManageMessage = () => import("../views/authservice/ManageMessage.vue");

// Member Components
const MemberLogin = () => import("../views/member/Login.vue");
const MemberJoin = () => import("../views/member/Join.vue");
const MemberFindPassword = () => import("../views/member/FindPassword.vue");
const MemberResetPassword = () => import("../views/member/ResetPassword.vue");

// Digital Components
const DigitalWarrantyPeriod = () => import("../views/digital/WarrantyPeriod.vue");
const DigitalCreateAuthcode = () => import("../views/digital/CreateAuthcode.vue");
const DigitalManageAuthcode = () => import("../views/digital/ManageAuthcode.vue");

// === Route Meta Constants ===
const ROUTE_META = {
  COMMON_LAYOUT_HIDDEN: {
    appCode: "common",
    hideLayout: true,
    requireMallId: false,
  },
  COMMON_LAYOUT_VISIBLE: {
    appCode: "common",
  },
  CERT_PRODUCT_BASIC_PLUS: {
    requireModes: ["basic", "plus"],
    appCode: "cert_product",
  },
  CERT_PRODUCT_PLUS_ONLY: {
    requireModes: ["plus"],
    appCode: "cert_product",
  },
  CERT_DIGITAL_BASIC_PLUS: {
    requireModes: ["basic", "plus"],
    appCode: "cert_digital",
  },
  COMMON_LAYOUT_HIDDEN_NO_AUTH: {
    appCode: "common",
    hideLayout: true,
    requireMallId: false,
    requireAuth: false,
  },
};

// === Helper Functions ===
const createAuthServiceRoute = (path, name, component, meta = {}) => ({
  path,
  name,
  component,
  props: true,
  meta,
});

const createDigitalRedirect = (to) => {
  const mallId = to.query.mall_id;
  const { mall_id, access_token, app_code = "cert_digital", shop_no } = to.query;

  console.log("Digital init redirect params:", { mallId: mall_id, access_token, app_code, shop_no });

  return mallId
    ? { path: `/authservice/${mallId}/digital/warrantyPeriod`, query: to.query }
    : { name: "DigitalWarrantyPeriod", query: to.query };
};

export const CAFE24_ROUTES = [
  // === Core Routes ===
  {
    path: "/",
    name: "Home",
    component: Home,
  },

  // === Information Routes (Landing Pages) ===
  {
    path: "/intro/",
    name: "Information",
    component: Information,
    meta: ROUTE_META.COMMON_LAYOUT_HIDDEN,
  },
  {
    path: "/authservice/info",
    name: "InformationAlias",
    component: Information,
    meta: ROUTE_META.COMMON_LAYOUT_HIDDEN,
  },

  // === Service Routes ===
  createAuthServiceRoute("/authservice/init", "ServiceInit", ServiceInit),
  createAuthServiceRoute("/authservice/:mall_id/serviceIntro", "ServiceIntro", ServiceIntro),

  // === Core AuthService Routes ===
  createAuthServiceRoute("/authservice/:mall_id/warrantyPeriod", "WarrantyPeriod", WarrantyPeriod, ROUTE_META.CERT_PRODUCT_BASIC_PLUS),
  createAuthServiceRoute("/authservice/:mall_id/createAuthcode", "CreateAuthcode", CreateAuthcode, ROUTE_META.CERT_PRODUCT_BASIC_PLUS),
  createAuthServiceRoute("/authservice/:mall_id/manageAuthcode", "ManageAuthcode", ManageAuthcode, ROUTE_META.CERT_PRODUCT_BASIC_PLUS),
  createAuthServiceRoute(
    "/authservice/:mall_id/manageAuthMembers",
    "ManageAuthMembers",
    ManageAuthMembers,
    ROUTE_META.CERT_PRODUCT_PLUS_ONLY,
  ),
  createAuthServiceRoute("/authservice/:mall_id/lostRecord", "LostRecord", LostRecord, ROUTE_META.CERT_PRODUCT_PLUS_ONLY),
  createAuthServiceRoute("/authservice/:mall_id/printqr", "Printqr", Printqr, ROUTE_META.CERT_PRODUCT_PLUS_ONLY),
  createAuthServiceRoute("/authservice/:mall_id/setting", "Setting", Setting, ROUTE_META.CERT_PRODUCT_BASIC_PLUS),

  // === Common Service Routes ===
  createAuthServiceRoute("/authservice/:mall_id/payment", "Payment", Payment, ROUTE_META.COMMON_LAYOUT_VISIBLE),
  createAuthServiceRoute(
    "/authservice/:mall_id/additionalService",
    "AdditionalService",
    AdditionalService,
    ROUTE_META.COMMON_LAYOUT_VISIBLE,
  ),
  createAuthServiceRoute("/authservice/:mall_id/messageManage", "ManageMessage", ManageMessage, {
    ...ROUTE_META.COMMON_LAYOUT_VISIBLE,
    requireModes: ["plus"],
  }),

  // === Digital Routes ===
  {
    path: "/authservice/digital/init",
    redirect: createDigitalRedirect,
  },
  createAuthServiceRoute(
    "/authservice/:mall_id/digital/warrantyPeriod",
    "DigitalWarrantyPeriod",
    DigitalWarrantyPeriod,
    ROUTE_META.CERT_DIGITAL_BASIC_PLUS,
  ),
  createAuthServiceRoute(
    "/authservice/:mall_id/digital/createAuthcode",
    "DigitalCreateAuthcode",
    DigitalCreateAuthcode,
    ROUTE_META.CERT_DIGITAL_BASIC_PLUS,
  ),
  createAuthServiceRoute(
    "/authservice/:mall_id/digital/manageAuthcode",
    "DigitalManageAuthcode",
    DigitalManageAuthcode,
    ROUTE_META.CERT_DIGITAL_BASIC_PLUS,
  ),
  createAuthServiceRoute(
    "/authservice/:mall_id/digital/messageManage",
    "DigitalManageMessage",
    ManageMessage,
    ROUTE_META.COMMON_LAYOUT_VISIBLE,
  ),

  // === Member Routes ===
  createAuthServiceRoute("/authservice/:mall_id/member/login", "MemberLogin", MemberLogin, {
    ...ROUTE_META.COMMON_LAYOUT_HIDDEN,
    requireMallId: true,
  }),
  createAuthServiceRoute("/authservice/join", "MemberJoin", MemberJoin, ROUTE_META.COMMON_LAYOUT_HIDDEN_NO_AUTH),
  createAuthServiceRoute("/authservice/find-password", "MemberFindPassword", MemberFindPassword, ROUTE_META.COMMON_LAYOUT_HIDDEN_NO_AUTH),
  createAuthServiceRoute(
    "/authservice/reset-password",
    "MemberResetPassword",
    MemberResetPassword,
    ROUTE_META.COMMON_LAYOUT_HIDDEN_NO_AUTH,
  ),
  {
    path: "/authservice/login",
    name: "CommonLogin",
    component: MemberLogin,
    props: false,
    meta: ROUTE_META.COMMON_LAYOUT_HIDDEN,
  },
];
